/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum RelationStatus {
  未建立 = 0,
  正式 = 1,
  体验限时 = 2,
  已过期 = 3,
}

export async function get_nearest_experience_relation(arg: any) {
  const res = await http.post(
    '/live/relation/get_nearest_experience_relation',
    {
      ...arg,
    }
  )
  return res.data.data
}

export const get_intimate_relation_banner = createAsyncThunk(
  'SocialRelationships/get_intimate_relation_banner',
  async (params: any, store: any) => {
    const {
      otherInfo: {target_mid, selected_relation_id},
    } = store.getState().env
    const resp = await http.post(
      '/live/gift/get_intimate_relation_banner',
      {
        to_mid: target_mid,
        selected_relation_id,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const update_relation_main = createAsyncThunk(
  'SocialRelationships/update_relation_main',
  async (params: any, store: any) => {
    const {otherInfo: {target_mid}} = store.getState().env
    const resp = await http.post(
      '/live/relation/update_relation_main',
      {
        to_mid: target_mid,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const update_relation_show = createAsyncThunk(
  'SocialRelationships/update_relation_show',
  async (params: any, store: any) => {
    const {otherInfo: {target_mid}} = store.getState().env
    const resp = await http.post(
      '/live/relation/update_relation_show',
      {
        to_mid: target_mid,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const get_pair_relation = createAsyncThunk(
  'SocialRelationships/get_pair_relation',
  async (params: any, store: any) => {
    const {otherInfo: {target_mid}} = store.getState().env
      // return {
      //     relation_name: '情侣',
      //     days: 5,
      //     is_experience: true,
      //     is_main: false,
      //     is_show: false,
      //     level: 4,
      //     experience_expire_at: 1787229915,
      //
      //     owner_avatar_frame: 'https://img01.mehiya.com/img/png/id/584002400810',
      //     owner_avatar: "http://me-media-gateway.test03.youyisia.com/accountv2/avatar/id/1094800900/sz/228",
      //     owner_mid: 17014001,
      //     owner_name: "Hiya_7995",
      //     target_avatar: "http://me-media-gateway.test03.youyisia.com/accountv2/avatar/id/1094812215/sz/228",
      //     target_mid: 18068818,
      //     target_name: "我成不了lv8大佬了",
      //     target_avatar_frame: 'https://img01.mehiya.com/img/png/id/584002400810',
      // }
    const resp = await http.post(
      '/live/relation/get_pair_relation',
      {
        to_mid: target_mid,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const task_homepage_v2 = createAsyncThunk(
  'SocialRelationships/task_homepage_v2',
  async (params: any, store: any) => {
    const {
      otherInfo: {target_mid, target_mid_other},
      deviceinfo: {h_m},
    } = store.getState().env
    const resp = await http.post(
      '/live/relation/task_homepage_v2',
      {
        target_mid: target_mid === h_m ? target_mid_other : target_mid,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.task_list || []
  }
)
export const get_relation_exclusive_backpack_items = createAsyncThunk(
  'SocialRelationships/get_relation_exclusive_backpack_items',
  async (params: any, store: any) => {
    const {
      otherInfo: {item_id},
    } = store.getState().env
    const resp = await http.post(
      '/live/privilege/get_relation_exclusive_backpack_item',
      {
        item_id,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data || {}
  }
)
export const get_relation_exclusive_activity = createAsyncThunk(
  'SocialRelationships/get_relation_exclusive_activity',
  async (params: any, store: any) => {
    const {
      otherInfo: {item_id, target_mid, target_mid_other},
      deviceinfo: {h_m},
    } = store.getState().env
    const resp = await http.post(
      '/live/relation/get_relation_exclusive_activity',
      {
        item_id,
        target_mid: target_mid === h_m ? target_mid_other : target_mid,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data || {}
  }
)
export const use_relation_exclusive_backpack_item = createAsyncThunk(
  'SocialRelationships/use_relation_exclusive_backpack_item',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/relation/use_relation_exclusive_backpack_item',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const send_relation = createAsyncThunk(
  'SocialRelationships/send_relation',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/relation/send_relation',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

const relation_establish = async (params: any, store: any) => {
  const {
    otherInfo: {item_id, target_mid, target_mid_other},
    deviceinfo: {h_m},
  } = store.getState().env
  if (params?.type === 2 && item_id <= 0) {
    return {err_msg: 'err'}
  }
  const resp = await http.post(
    '/live/privilege/get_relation_establish_page',
    {
      item_id,
      target_mid: target_mid === h_m ? target_mid_other : target_mid,
      ...params,
    },
    {store, xcErrorToast: true}
  )
  return resp.data.data || {}
}

export const get_relation_establish_page = createAsyncThunk(
  'SocialRelationships/get_relation_establish_page',
  (params: any, store: any) => relation_establish(params, store)
)
export const get_relation_establish_page_1 = createAsyncThunk(
  'SocialRelationships/get_relation_establish_page_1',
  (params: any, store: any) => relation_establish({type: 1}, store)
)
export const get_relation_establish_page_2 = createAsyncThunk(
  'SocialRelationships/get_relation_establish_page_2',
  (params: any, store: any) => relation_establish({type: 2}, store)
)
const initialState: {
  home: any
  set: any
  banner: any
  taskList: Array<any>
  popUp: any
  half: any
  base: {
    showRuleBtn: boolean
    showRewardBtn: boolean
  }
} = {
  home: {},
  set: {},
  banner: {},
  taskList: [],
  popUp: {},
  half: {},
  base: {
    showRuleBtn: false,
    showRewardBtn: false,
  },
}

export const SocialRelationshipsSlice = createSlice({
  name: 'SocialRelationships',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_intimate_relation_banner.fulfilled, (state, action) => {
      Object.assign(state.banner, action.payload)
    })
    builder.addCase(get_pair_relation.fulfilled, (state, action) => {
      Object.assign(state.set, action.payload)
    })
    builder.addCase(task_homepage_v2.fulfilled, (state, action) => {
      Object.assign(state.taskList, action.payload)
    })
    builder.addCase(
      get_relation_exclusive_backpack_items.fulfilled,
      (state, action) => {
        Object.assign(state.popUp, action.payload)
      }
    )
    builder.addCase(
      get_relation_exclusive_activity.fulfilled,
      (state, action) => {
        Object.assign(state.home, action.payload)
      }
    )
    builder.addCase(get_relation_establish_page.fulfilled, (state, action) => {
      Object.assign(state.half, action.payload)
    })
    builder.addCase(
      get_relation_establish_page_2.fulfilled,
      (state, action) => {
        const {err_msg} = action.payload
        Object.assign(state.base, {showRuleBtn: !err_msg})
      }
    )
    builder.addCase(
      get_relation_establish_page_1.fulfilled,
      (state, action) => {
        const {err_msg} = action.payload
        Object.assign(state.base, {showRewardBtn: !err_msg})
      }
    )
  },
})

export default SocialRelationshipsSlice.reducer
export const SocialRelationshipsActions = SocialRelationshipsSlice.actions

export const useSocialRelationshipsState = () => {
  return useSelector((state) => state.SocialRelationships)
}
